/**
 * Placeholder linked accounts for the flag-gated preview. Replaced by the
 * user's real institutions once the runtime API lands (CORE-7540).
 */
export interface MockAccount {
  id: string
  name: string
  mask: string
}

export interface MockInstitution {
  id: string
  name: string
  /** Used only as a fallback when `name` has no entry in
   * `institutionLogoMap` (matches OnboardingInstitutionCard's own
   * fallback for institutions Plaid didn't return a logo for). */
  iconColor: 'loud' | 'black'
  accounts: MockAccount[]
}

export const INSTITUTIONS: MockInstitution[] = [
  {
    id: 'chase',
    name: 'Chase',
    iconColor: 'black',
    accounts: [
      {
        id: 'chase-business',
        name: 'Total Business Checking',
        mask: '7734',
      },
      { id: 'chase-personal', name: 'Personal Checking', mask: '2290' },
    ],
  },
  {
    id: 'wells-fargo',
    name: 'Wells Fargo',
    iconColor: 'black',
    accounts: [
      { id: 'wells-fargo-checking', name: 'Business Checking', mask: '4821' },
    ],
  },
  {
    id: 'citibank',
    name: 'Citibank Online',
    iconColor: 'black',
    accounts: [{ id: 'citibank-savings', name: 'Savings', mask: '5563' }],
  },
]

export const ALL_ACCOUNTS = INSTITUTIONS.flatMap(
  (institution) => institution.accounts
)
